<template>
  <div>
    <v-card v-show="!showUserProfile" class="card-shadow border-radius-xl">
      <v-card-title>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn-toggle v-model="viewMode" mandatory dense>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn value="list" large v-bind="attrs" v-on="on">
                    <v-icon>mdi-format-list-bulleted</v-icon>
                    <span class="ml-1">列表</span>
                  </v-btn>
                </template>
                <span>列表顯示</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn value="grid" large v-bind="attrs" v-on="on">
                    <v-icon>mdi-grid</v-icon>
                    <span class="ml-1">格狀</span>
                  </v-btn>
                </template>
                <span>格狀顯示</span>
              </v-tooltip>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle>
        <!-- Search and Add User Controls -->
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              hide-details
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
              height="43"
              v-model="search"
              placeholder="姓名"
              clearable
              @input="onSearchInput"
            >
              <template slot="prepend-inner">
                <v-icon color="#adb5bd" size=".875rem">fas fa-search</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2" class="d-flex align-center">
            <v-select
              v-model="statusFilter"
              :items="statusOptions"
              item-text="text"
              item-value="value"
              hide-details
              dense
              outlined
              class="
                mt-0
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              label="狀態"
              @change="onStatusChange"
            ></v-select>
          </v-col>
          <v-col cols="12" md="2" class="d-flex align-center">
            <v-select
              v-model="approvalStatusFilter"
              :items="approvalStatusOptions"
              item-text="text"
              item-value="value"
              hide-details
              dense
              outlined
              class="
                mt-0
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              label="審核狀態"
              @change="onApprovalStatusChange"
            ></v-select>
          </v-col>
          <v-spacer></v-spacer>

          <v-col cols="12" lg="auto" class="px-0">
            <v-row no-gutters class="w-100">
              <v-col cols="6" lg="auto" class="px-1">
                <v-dialog v-model="dialog" max-width="900px" scrollable>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="startCreateUser"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="
                        font-weight-bold
                        text-capitalize
                        btn-ls btn-primary
                        bg-gradient-primary
                        py-3
                        px-6
                        w-100
                      "
                    >
                      <v-icon size="18" class="me-1">mdi-account-plus</v-icon>
                      新增員工
                    </v-btn>
                  </template>
                  <v-card class="card-shadow border-radius-xl">
                    <div class="card-header-padding card-border-bottom">
                      <span class="font-weight-bold text-h5 text-typo mb-0"
                        >新增員工</span
                      >
                      <span class="text-caption text-medium-emphasis">
                        預設密碼: {{ DEFAULT_PASSWORD }}</span
                      >
                    </div>
                    <v-card-text class="card-padding" style="max-height: 600px">
                      <v-tabs v-model="activeTab" class="mb-4">
                        <v-tab :ripple="false" href="#tab-1">
                          <span class="ms-1">基本資料</span>
                        </v-tab>
                        <v-tab :ripple="false" href="#tab-2">
                          <span class="ms-1">僱用資料</span>
                        </v-tab>
                        <v-tab :ripple="false" href="#tab-3">
                          <span class="ms-1">薪水資訊</span>
                        </v-tab>
                      </v-tabs>

                      <leave-of-absence-widget
                        v-if="editedItem.id"
                        class="mt-4"
                        :target-user-id="editedItem.id"
                      />

                      <v-tabs-items v-model="activeTab" class="mt-4">
                        <v-tab-item value="tab-1">
                          <basic-info-widget
                            ref="basicInfoWidget"
                            :profile-data="editedItem"
                            :is-create-mode="true"
                            @save="onWidgetSave"
                          ></basic-info-widget>
                        </v-tab-item>
                        <v-tab-item value="tab-2">
                          <employment-info-widget
                            ref="employmentInfoWidget"
                            :profile-data="editedItem"
                            :is-create-mode="true"
                            @save="onWidgetSave"
                          ></employment-info-widget>
                        </v-tab-item>
                        <v-tab-item value="tab-3">
                          <salary-info-widget
                            ref="salaryInfoWidget"
                            :profile-data="editedItem"
                            :is-create-mode="true"
                            @save="onWidgetSave"
                          ></salary-info-widget>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card-text>

                    <v-card-actions class="card-padding d-flex justify-end">
                      <v-btn
                        @click="close"
                        elevation="0"
                        :ripple="false"
                        height="43"
                        class="
                          font-weight-bold
                          text-capitalize
                          btn-ls btn-secondary
                          bg-gradient-light
                          py-3
                          px-6
                          me-2
                        "
                        >取消</v-btn
                      >

                      <v-btn
                        @click="save"
                        elevation="0"
                        :ripple="false"
                        height="43"
                        :loading="saving"
                        class="
                          font-weight-bold
                          text-capitalize
                          btn-ls btn-primary
                          bg-gradient-primary
                          py-3
                          px-6
                        "
                        >儲存</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>

              <v-col cols="6" lg="auto" class="px-1">
                <input
                  ref="bulkFileInput"
                  type="file"
                  class="d-none"
                  accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  @change="onBulkFileChange"
                />

                <v-btn
                  @click="openBulkDialog"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-ls btn-default
                    bg-gradient-default
                    py-3
                    px-6
                    w-100
                  "
                >
                  <v-icon size="18" class="me-1"
                    >mdi-file-upload-outline</v-icon
                  >
                  匯入名冊
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <!-- Bulk Upload Dialog -->
          <v-dialog v-model="bulkUploadDialog" max-width="600px">
            <v-card class="card-shadow border-radius-xl">
              <div class="card-header-padding card-border-bottom">
                <span class="font-weight-bold text-h5 text-typo mb-0"
                  >匯入名冊</span
                >
              </div>
              <v-card-text class="card-padding">
                <v-container class="px-0">
                  <v-row>
                    <v-col cols="12">
                      <v-file-input
                        v-model="bulkUploadFile"
                        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        label="選擇 Excel 檔案 (.xlsx)"
                        prepend-icon="mdi-file-excel"
                        dense
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" class="d-flex align-center">
                      <v-icon size="18" class="me-2"
                        >mdi-file-download-outline</v-icon
                      >
                      <a
                        :href="sampleTemplateUrl"
                        target="_blank"
                        rel="noopener"
                        download
                      >
                        下載範例檔
                      </a>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions class="card-padding d-flex justify-end">
                <v-btn
                  @click="cancelBulkUpload"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-ls btn-secondary
                    bg-gradient-light
                    py-3
                    px-6
                    me-2
                  "
                  >取消</v-btn
                >
                <v-btn
                  @click="confirmBulkUpload"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-ls btn-primary
                    bg-gradient-primary
                    py-3
                    px-6
                  "
                  >確認</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card class="card-shadow card-padding border-radius-xl">
              <v-card-title class="pt-0 text-h5 text-typo justify-center"
                >你確定要刪除該員工嗎?</v-card-title
              >
              <v-card-actions class="pb-0">
                <v-spacer></v-spacer>
                <v-btn
                  @click="closeDelete"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-ls
                    bg-gradient-light
                    py-3
                    px-6
                  "
                  >取消</v-btn
                >

                <v-btn
                  @click="deleteItemConfirm"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-ls btn-primary
                    bg-gradient-primary
                    py-3
                    px-6
                  "
                  >確定</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogSendMessage" max-width="500px">
            <v-card class="card-shadow border-radius-xl">
              <div class="card-header-padding card-border-bottom">
                <span class="font-weight-bold text-h5 text-typo mb-0"
                  >傳送訊息</span
                >
              </div>
              <v-card-text class="card-padding">
                <v-container class="px-0">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.message"
                        hide-details
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                        height="43"
                        placeholder="message"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="card-padding d-flex justify-end">
                <v-btn
                  @click="dialogSendMessage = false"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-ls btn-secondary
                    bg-gradient-light
                    py-3
                    px-6
                  "
                  >Cancel</v-btn
                >

                <v-btn
                  @click="sendMessageToUser"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-ls btn-primary
                    bg-gradient-primary
                    py-3
                    px-6
                  "
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-card-subtitle>
      <v-card-text class="px-0 py-0">
        <!-- List View -->
        <v-data-table
          v-if="viewMode === 'list'"
          :headers="headers"
          :items="users"
          :loading="loading"
          :server-items-length="totalItems"
          class="table"
          hide-default-footer
          @page-count="pageCount = $event"
          disable-pagination
          :items-per-page="itemsPerPage"
          mobile-breakpoint="0"
          :item-class="rowClass"
          @click:row="(item) => viewProfile(item)"
        >
          <template v-slot:item.is_active="{ item }">
            <div class="d-flex align-center">
              <span
                class="rounded-circle"
                :class="{
                  'bg-success': item.is_active,
                  'bg-danger': !item.is_active,
                }"
                style="width: 12px; height: 12px"
              ></span>
            </div>
          </template>
          <template v-slot:item.name="{ item }">
            <div class="d-flex align-center">
              <span class="text-sm font-weight-normal text-body">
                {{ item.name }}
              </span>
            </div>
          </template>

          <template v-slot:item.email="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.email }}
            </span>
          </template>

          <template v-slot:item.mobile_phone="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.mobile_country_code }} {{ item.mobile_phone }}
            </span>
          </template>

          <template v-slot:item.job_title="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.job_title }}
            </span>
          </template>

          <template v-slot:item.department="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.department }}
            </span>
          </template>

          <template v-slot:item.role="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ ROLE_MAPPING[item.role] || item.role }}
            </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              @click.stop="viewProfile(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#344767"
              title="查看使用者"
            >
              <v-icon size="18">ni-single-02</v-icon>
            </v-btn>

            <!-- <v-btn
              @click="editItem(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
            >
              <v-icon size="18">ni-ruler-pencil</v-icon>
            </v-btn> -->

            <v-btn
              @click.stop="showSendMessage(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
              title="發送訊息"
            >
              <v-icon size="18">mdi-message text-lg</v-icon>
            </v-btn>

            <v-btn
              v-if="item.is_active === false"
              @click.stop="reactivateItem(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-md"
              color="#67748e"
            >
              <v-icon size="12">ni-button-play text-lg</v-icon>
            </v-btn>
            <v-btn
              v-if="item.is_active === true && canDeactivateUser(item)"
              @click.stop="deleteItem(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-md"
              color="#67748e"
              title="停用"
            >
              <v-icon color="orange" size="12">ni-button-pause text-lg</v-icon>
            </v-btn>
            <v-btn
              v-if="isHoldingTransferAllowed()"
              @click.stop="promptTransferToHolding(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-md"
              color="#5e72e4"
              title="刪除"
            >
              <v-icon size="14" color="red">mdi-close-thick text-lg</v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <!-- Grid View -->
        <div v-if="viewMode === 'grid'" class="grid-view-container">
          <!-- Grid items -->
          <v-row>
            <v-col
              v-for="(user, index) in users"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="mb-4"
            >
              <v-card
                class="user-card h-100 card-shadow border-radius-xl"
                @click="viewProfile(user)"
                style="cursor: pointer"
              >
                <v-card-text class="pa-4">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="d-flex justify-space-between align-center">
                        <div>
                          <h3 class="font-weight-bold mb-0">{{ user.name }}</h3>
                          <p class="text-body-2 mb-0">{{ user.job_title }}</p>
                        </div>
                        <v-chip
                          x-small
                          label
                          color="light-green"
                          text-color="white"
                          class="px-2"
                          >active</v-chip
                        >
                      </div>
                    </div>
                  </div>

                  <div class="mt-4">
                    <div class="d-flex align-center mb-2">
                      <v-icon size="18" color="grey" class="mr-2"
                        >mdi-email</v-icon
                      >
                      <span class="text-body-1">{{ user.email }}</span>
                    </div>

                    <div class="d-flex align-center mb-2">
                      <v-icon size="18" color="grey" class="mr-2"
                        >mdi-phone</v-icon
                      >
                      <span class="text-body-2"
                        >{{ user.mobile_country_code || "+1" }}
                        {{ user.mobile_phone }}</span
                      >
                    </div>

                    <div class="d-flex align-center mb-2">
                      <v-icon size="18" color="grey" class="mr-2"
                        >mdi-office-building</v-icon
                      >
                      <span class="text-body-2">{{ user.department }}</span>
                    </div>
                  </div>

                  <div class="mt-3 pt-2 border-top">
                    <div class="d-flex align-center text-body-2">
                      <span class="text-grey"
                        >Joined:
                        {{
                          user.created_at
                            ? new Date(user.created_at).toLocaleDateString()
                            : "1/15/2022"
                        }}</span
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        small
                        class="mr-1"
                        @click.stop="editItem(user)"
                      >
                        <v-icon size="18">mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn icon small @click.stop="showSendMessage(user)">
                        <v-icon size="18">mdi-message</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- No results message -->
          <v-row v-if="users.length === 0 && !loading">
            <v-col cols="12" class="text-center">
              <p class="text-body">No users found</p>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div ref="sentinel" class="d-flex justify-center py-4">
        <v-progress-circular
          v-if="loadingMore"
          indeterminate
          color="#cb0c9f"
          size="24"
        ></v-progress-circular>
      </div>
    </v-card>

    <!-- Progress Dialog -->
    <ProgressDialog :visible="showProgressDialog" :message="progressMessage" />

    <!-- Info Dialog -->
    <InfoDialog
      :visible="infoDialog.visible"
      :title="infoDialog.title"
      :message="infoDialog.message"
      :yes-button-text="infoDialog.yesButtonText"
      :yes-callback="infoDialog.yesCallback"
      @update:visible="infoDialog.visible = $event"
    />

    <!-- Confirm Dialog -->
    <confirm-dialog
      :visible.sync="confirmDialog.visible"
      :title="confirmDialog.title"
      :message="confirmDialog.message"
      :yes-button-text="confirmDialog.yesButtonText"
      :no-button-text="confirmDialog.noButtonText"
      :yes-callback="confirmDialog.yesCallback"
    />

    <!-- User Profile Component -->
    <user-profile
      v-if="showUserProfile"
      :userId="selectedUserId"
      @back="handleBack"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ProgressDialog from "@/components/Common/ProgressDialog.vue";
import InfoDialog from "@/components/Common/InfoDialog.vue";
import ConfirmDialog from "@/components/Common/ConfirmDialog.vue";
import UserProfile from "@/views/Pages/Users/UserProfile.vue";
import BasicInfoWidget from "@/views/Pages/Users/Widgets/ProfileWidgets/BasicInfoWidget.vue";
import EmploymentInfoWidget from "@/views/Pages/Users/Widgets/ProfileWidgets/EmploymentInfoWidget.vue";
import SalaryInfoWidget from "@/views/Pages/Users/Widgets/ProfileWidgets/SalaryInfoWidget.vue";
import LeaveOfAbsenceWidget from "@/components/Widgets/LeaveOfAbsenceWidget.vue";
import { ROLE_MAPPING, DEFAULT_PASSWORD } from "@/constants";

export default {
  name: "paginated-tables",
  components: {
    ProgressDialog,
    InfoDialog,
    ConfirmDialog,
    UserProfile,
    BasicInfoWidget,
    EmploymentInfoWidget,
    SalaryInfoWidget,
    LeaveOfAbsenceWidget,
  },
  props: {
    companyId: {
      type: [String, Number],
      default: null,
    },

  },
  data() {
    return {
      DEFAULT_PASSWORD,
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
      loadingMore: false,
      observer: null,
      dialog: false,
      dialogDelete: false,
      dialogSendMessage: false,
      users: [],
      search: "",
      searchDebounceTimer: null,
      statusFilter: "active",
      approvalStatusFilter: null,
      statusOptions: [
        { text: "全部", value: "all" },
        { text: "啟用中", value: "active" },
        { text: "停用中", value: "disable" },
      ],
      approvalStatusOptions: [
        { text: "全部", value: null },
        { text: "待審核", value: "待審核" },
        { text: "審核中", value: "審核中" },
        { text: "審核退回", value: "審核退回" },
        { text: "審核通過", value: "審核通過" },
      ],
      loading: false,
      totalItems: 0,
      // Company data now comes from Vuex store
      showProgressDialog: false,
      progressMessage: "Loading users...",
      showUserProfile: false,
      selectedUserId: null,
      viewMode: "list", // Default view mode (list or grid)
      editedIndex: -1,
      activeTab: "tab-1",
      saving: false,
      infoDialog: {
        visible: false,
        title: "",
        message: "",
        yesButtonText: "確定",
        yesCallback: null,
      },
      confirmDialog: {
        visible: false,
        title: "確認",
        message: "",
        yesButtonText: "確定",
        noButtonText: "取消",
        yesCallback: null,
      },
      bulkUploadDialog: false,
      bulkUploadFile: null,
      editedItem: {
        id: null,
        name: "",
        english_name: "",
        member_id: "",
        mobile_country_code: "+886",
        user_mobile_phone: "",
        user_email: "",
        user_company: "",
        department: "",
        job_title: "",
        contact_person: "",
        contact_phone: "",
        contact_relation: "",
        employment_type: null,
        join_type: 1,
        work_type: 0,
        contract_work_type: 1,
        contract_salary_type: 1,
        hourly_salary_type: null,
        part_time_monthly_hours: null,
        part_time_hourly_wage: null,
        part_time_hourly_contract_hours: null,
        duration: null,
        expected_sign_date: "",
        expected_resign_date: null,
        blood_type: "",
        native_place: "",
        insured_unit: "",
        note: "",
        basic_salary: 0,
        extra_salary: "",
        salary_settle_freq: 0,
        salary_settle_date: 0,
        salary_pay_freq: 0,
        salary_pay_date: 0,
        salary_account: "",
        bank: "",
        branch: "",
        supervisor_allowance: 0,
        position_allowance: 0,
        food_allowance: 0,
        company_extra_salary: {},
        employee_welfare_fund: 0,
        bonus: 0,
        employee_voluntary_pension: false,
        employee_voluntary_pension_rate: 0,
        insurance_bracket_max: null,
        dependent_insured_count: 0,
        extra_insurance: null,
        message: "",
        password: DEFAULT_PASSWORD,
      },
      defaultItem: {
        id: null,
        name: "",
        english_name: "",
        member_id: "",
        mobile_country_code: "+886",
        user_mobile_phone: "",
        user_email: "",
        user_company: "",
        department: "",
        job_title: "",
        contact_person: "",
        contact_phone: "",
        contact_relation: "",
        employment_type: null,
        join_type: 1,
        work_type: 0,
        contract_work_type: 1,
        contract_salary_type: 1,
        hourly_salary_type: null,
        part_time_monthly_hours: null,
        part_time_hourly_wage: null,
        part_time_hourly_contract_hours: null,
        duration: null,
        expected_sign_date: "",
        expected_resign_date: null,
        blood_type: "",
        native_place: "",
        insured_unit: "",
        note: "",
        basic_salary: 0,
        extra_salary: "",
        salary_settle_freq: 0,
        salary_settle_date: 0,
        salary_pay_freq: 0,
        salary_pay_date: 0,
        salary_account: "",
        bank: "",
        branch: "",
        supervisor_allowance: 0,
        position_allowance: 0,
        food_allowance: 0,
        company_extra_salary: {},
        employee_welfare_fund: 0,
        bonus: 0,
        employee_voluntary_pension: false,
        employee_voluntary_pension_rate: 0,
        insurance_bracket_max: null,
        dependent_insured_count: 0,
        extra_insurance: null,
        message: "",
        password: DEFAULT_PASSWORD,
      },
      headers: [
        // is_active
        {
          text: "啟用",
          value: "is_active",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "姓名",
          align: "start",
          cellClass: "border-bottom",
          sortable: false,
          value: "name",
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "手機",
          value: "mobile_phone",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "部門",
          value: "department",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        // member_id
        {
          text: "工號",
          value: "member_id",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        // job_title
        {
          text: "職位",
          value: "job_title",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },

        // role
        {
          text: "角色",
          value: "role",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        // approval_status
        {
          text: "審核狀態",
          value: "approval_status",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7 black--text",
        },
      ],
      ROLE_MAPPING: ROLE_MAPPING,
    };
  },
  computed: {
    ...mapGetters("user", ["userToken", "userRole", "userId"]),
    ...mapGetters("company", ["companies", "selectedCompany"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    // Get company_id from selectedCompany
    company_id() {
      return this.selectedCompany ? this.selectedCompany.id : null;
    },
    company_name() {
      return this.selectedCompany ? this.selectedCompany.company_name : "";
    },
    sampleTemplateUrl() {
      return `${process.env.VUE_APP_API_URL}/resource/samples/sample.xlsx`;
    },
  },
  async mounted() {
    try {
      // Set default view mode based on device
      if (this.$vuetify.breakpoint.mobile) {
        this.viewMode = "grid";
      }

      // Add event listeners for company changes
      this.$root.$on("company-changed", this.handleCompanyChanged);
      this.$root.$on("refresh-users-data", this.fetchUsers);

      // Initial fetch of users based on current selected company
      await this.fetchUsers();
      this.initIntersectionObserver();
    } catch (error) {
      console.error("Error in mounted:", error);
      alert("Failed to initialize component");
    }
  },

  beforeDestroy() {
    // Clean up event listeners
    this.$root.$off("company-changed", this.handleCompanyChanged);
    this.$root.$off("refresh-users-data", this.fetchUsers);

    // Clean up debounce timer
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    openBulkDialog() {
      this.bulkUploadDialog = true;
    },
    cancelBulkUpload() {
      this.bulkUploadDialog = false;
      this.bulkUploadFile = null;
    },
    async confirmBulkUpload() {
      if (!this.bulkUploadFile) {
        this.infoDialog.title = "提示";
        this.infoDialog.message = "請先選擇要上傳的檔案 (.xlsx)";
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
        return;
      }
      this.bulkUploadDialog = false;
      this.showProgressDialog = true;
      this.progressMessage = "正在上傳檔案...";
      const start = Date.now();
      try {
        await this.performBulkUpload();
      } finally {
        const elapsed = Date.now() - start;
        const remain = 500 - elapsed;
        if (remain > 0) {
          await new Promise((r) => setTimeout(r, remain));
        }
        this.showProgressDialog = false;
      }
    },
    viewProfile(item) {
      // Set the selected user ID and show the profile component
      this.selectedUserId = item.id;
      this.showUserProfile = true;
    },
    handleBack() {
      this.showUserProfile = false;
      this.$nextTick(() => {
        this.scrollToUser(this.selectedUserId);
      });
      // this.fetchUsers();
    },
    rowClass(item) {
      return `user-row-${item.id}`;
    },
    scrollToUser(userId) {
      if (!userId) return;
      const element = document.querySelector(`.user-row-${userId}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    canDeactivateUser(item) {
      if (this.userRole !== "hr") return true;
      const currentId = this.userId ? Number(this.userId) : null;
      const targetId = item?.user_id ?? item?.id ?? null;
      if (currentId == null || targetId == null) return true;
      return Number(targetId) !== currentId;
    },
    isHoldingTransferAllowed() {
      const allowed = ["superadmin", "consultant", "hr"];
      return allowed.includes(this.userRole);
    },
    promptTransferToHolding(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.confirmDialog.title = "確認刪除";
      this.confirmDialog.message = `將員工 "${item.name}" 刪除？\n一經刪除確定，該員工任職期間一切資料均消滅，且無法回復`;
      this.confirmDialog.yesButtonText = "確定";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        await this.transferToHoldingConfirm();
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
    },

    async transferToHoldingConfirm() {
      try {
        this.showProgressDialog = true;
        this.progressMessage = "正在刪除員工...";

        const { id, name } = this.editedItem;
        const resp = await this.$axios.post(`/api/users/${id}/transfer-to-holding`);

        this.showProgressDialog = false;

        const { holding_company_id: companyId, created } = resp.data || {};
        const createdMsg = created ? "（已自動建立公司）" : "";
        const companyMsg = companyId ? `（公司ID: ${companyId}）` : "";

        this.infoDialog.title = "操作成功";
        this.infoDialog.message = `員工 "${name}" 已刪除。`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = async () => {
          await this.fetchUsers();
          this.infoDialog.yesCallback = null;
        };
        this.infoDialog.visible = true;
      } catch (error) {
        this.showProgressDialog = false;
        const errorMsg = error.response?.data?.message || error.message || "刪除失敗";
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = `刪除失敗：${errorMsg}`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      }
    },
    onStatusChange() {
      this.page = 1; // Reset to first page
      this.fetchUsers();
    },
    onApprovalStatusChange() {
      this.page = 1;
      this.fetchUsers();
    },
    async fetchUsers(append = false) {
      try {
        if (append) {
          this.loadingMore = true;
        } else {
          this.loading = true;
          this.showProgressDialog = true;
          this.progressMessage = "Fetching user data...";
        }

        // Build query parameters
        let queryParams = `page=${this.page}&limit=${this.itemsPerPage}`;
        if (this.selectedCompany && this.selectedCompany.id) {
          queryParams += `&company_id=${this.selectedCompany.id}`;
        }

        if (this.search && this.search.trim()) {
          queryParams += `&name=${encodeURIComponent(this.search.trim())}`;
        }

        // Apply status filter
        if (this.statusFilter === "active") {
          queryParams += `&is_active=1`;
        } else if (this.statusFilter === "disable") {
          queryParams += `&is_active=0`;
        }

        if (this.approvalStatusFilter) {
          queryParams += `&approval_status=${encodeURIComponent(
            this.approvalStatusFilter
          )}`;
        }

        // Use axios to fetch users; auth header is injected by interceptor
        const response = await this.$axios.get(`/api/users?${queryParams}`);

        if (append) {
          this.users = [...this.users, ...response.data.data];
        } else {
          this.users = response.data.data;
        }
        this.pagination = response.data.pagination;
        this.pageCount = this.pagination.totalPages;
        this.totalItems = this.pagination.totalItems;
      } catch (error) {
        console.error("Error fetching users:", error);
        this.progressMessage = "Error loading data...";
      } finally {
        this.loading = false;
        this.loadingMore = false;
        if (!append) {
          // Hide progress dialog after a short delay to show completion
          setTimeout(() => {
            this.showProgressDialog = false;
          }, 100);
        }
      }
    },

    onSearchInput() {
      // Clear existing timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      // Set new timer for 500ms debounce
      this.searchDebounceTimer = setTimeout(() => {
        this.page = 1; // Reset to first page when searching
        this.fetchUsers();
      }, 500);
    },

    initIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      };
      this.observer = new IntersectionObserver((entries) => {
        const target = entries[0];
        if (
          target.isIntersecting &&
          !this.loading &&
          !this.loadingMore &&
          this.page < this.pageCount
        ) {
          this.page += 1;
          this.fetchUsers(true);
        }
      }, options);

      const target = this.$refs.sentinel;
      if (target) {
        this.observer.observe(target);
      }
    },

    async onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.page = 1;
      await this.fetchUsers();
    },

    async onCompanyChange(company) {
      if (company) {
        this.company_id = company.id;
        this.page = 1; // Reset to first page when changing company

        // Update Vuex store with selected company
        this.$store.dispatch("company/selectCompany", company.id);

        await this.fetchUsers();
      }
    },

    // Handle company changes from other components (like AppBar)
    async handleCompanyChanged(company) {
      if (company && company.id !== this.company_id) {
        console.log("handle company changed ", company);
        this.selectedCompany = company;
        this.company_id = company.id;
        this.page = 1; // Reset to first page when changing company
        await this.fetchUsers();
      }
    },

    startCreateUser() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.activeTab = "tab-1";
    },

    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, this.defaultItem, {
        id: item.id,
        name: item.name,
        email: item.email,
        mobile_phone: item.mobile_phone,
        job_title: item.job_title,
        department: item.department,
      });
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // Show confirm dialog
      this.confirmDialog.title = "確認停用";
      this.confirmDialog.message = `你確定要停用員工 "${item.name}" 嗎？`;
      this.confirmDialog.yesButtonText = "確定";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        await this.deleteItemConfirm();
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
    },
    showSendMessage(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogSendMessage = true;
    },

    async deleteItemConfirm() {
      try {
        this.showProgressDialog = true;
        this.progressMessage = "正在停用員工...";

        await this.$axios.delete(`/api/users/${this.editedItem.id}`);

        this.showProgressDialog = false;

        // Show success dialog
        this.infoDialog.title = "操作成功";
        this.infoDialog.message = `員工 "${this.editedItem.name}" 已成功停用！`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = async () => {
          await this.fetchUsers();
          this.infoDialog.yesCallback = null;
        };
        this.infoDialog.visible = true;

        // Reset edited item
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      } catch (error) {
        console.error("Error deleting user:", error);
        this.showProgressDialog = false;
        const errorMsg =
          error.response?.data?.message || error.message || "停用失敗";
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = `停用員工失敗：${errorMsg}`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      }
    },

    reactivateItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);

      // Show confirm dialog
      this.confirmDialog.title = "確認重新啟用";
      this.confirmDialog.message = `你確定要重新啟用員工 "${item.name}" 嗎？`;
      this.confirmDialog.yesButtonText = "確定";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        await this.reactivateItemConfirm();
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
    },

    async reactivateItemConfirm() {
      try {
        this.showProgressDialog = true;
        this.progressMessage = "正在重新啟用員工...";

        await this.$axios.post(`/api/users/${this.editedItem.id}/reactivate`);

        this.showProgressDialog = false;

        // Show success dialog
        this.infoDialog.title = "操作成功";
        this.infoDialog.message = `員工 "${this.editedItem.name}" 已成功重新啟用！`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = async () => {
          await this.fetchUsers();
          this.infoDialog.yesCallback = null;
        };
        this.infoDialog.visible = true;

        // Reset edited item
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      } catch (error) {
        console.error("Error reactivating user:", error);
        this.showProgressDialog = false;
        const errorMsg =
          error.response?.data?.message || error.message || "重新啟用失敗";
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = `重新啟用員工失敗：${errorMsg}`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.activeTab = "tab-1";
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    onWidgetSave(payload, done) {
      // Merge widget data into editedItem
      Object.assign(this.editedItem, payload);
      if (done) done(true);
    },

    async save() {
      try {
        this.saving = true;
        // Prepare user data for API
        const userData = {
          mobile_country_code: this.editedItem.mobile_country_code || "+886",
          mobile_phone: this.editedItem.user_mobile_phone || "",
          password: this.editedItem.password || DEFAULT_PASSWORD,
          name: this.editedItem.name || "",
          email: this.editedItem.user_email || "",
          role: this.editedItem.role || "employee",
          approval_status: this.editedItem.approval_status || "待審核",
          company: this.company_name || "",
          department: this.editedItem.department || "",
          store: this.editedItem.store || "",
          job_title: this.editedItem.job_title || "",
          identity: "",
          is_active: true,
          is_superuser: false,
          company_id: this.company_id || 0,
          employee_id: this.editedItem.member_id || "",
          profile: {
            join_type: this.editedItem.join_type ?? 1,
            member_id: this.editedItem.member_id || "",
            duration: this.editedItem.duration || 0,
            expected_sign_date: this.editedItem.expected_sign_date || null,
            expected_resign_date: this.editedItem.expected_resign_date || null,
            employment_type: this.editedItem.employment_type || 0,
            work_type:
              this.editedItem.work_type != null ? this.editedItem.work_type : 0,
            contract_work_type:
              this.editedItem.contract_work_type != null
                ? this.editedItem.contract_work_type
                : 0,
            contract_work_type_class_id: 0,
            contract_salary_type:
              this.editedItem.contract_salary_type != null
                ? this.editedItem.contract_salary_type
                : 0,
            hourly_salary_type:
              this.editedItem.contract_salary_type === 2
                ? this.editedItem.hourly_salary_type ?? null
                : null,
            part_time_monthly_hours:
              this.editedItem.contract_salary_type === 1
                ? this.editedItem.part_time_monthly_hours ?? null
                : null,
            part_time_hourly_wage:
              this.editedItem.contract_salary_type === 2
                ? this.editedItem.part_time_hourly_wage ?? null
                : null,
            part_time_hourly_contract_hours:
              this.editedItem.contract_salary_type === 2
                ? this.editedItem.part_time_hourly_contract_hours ?? null
                : null,
            basic_salary: Number(this.editedItem.basic_salary) || 0,
            extra_salary: this.editedItem.extra_salary || "",
            salary_settle_freq:
              this.editedItem.salary_settle_freq != null
                ? this.editedItem.salary_settle_freq
                : 0,
            salary_settle_date:
              this.editedItem.salary_settle_date != null
                ? this.editedItem.salary_settle_date
                : 0,
            salary_pay_freq:
              this.editedItem.salary_pay_freq != null
                ? this.editedItem.salary_pay_freq
                : 0,
            salary_pay_date:
              this.editedItem.salary_pay_date != null
                ? this.editedItem.salary_pay_date
                : 0,
            salary_account: this.editedItem.salary_account || "",
            bank: this.editedItem.bank || "",
            branch: this.editedItem.branch || "",
            supervisor_allowance: this.editedItem.supervisor_allowance || 0,
            position_allowance: this.editedItem.position_allowance || 0,
            food_allowance: this.editedItem.food_allowance || 0,
            company_extra_salary: this.editedItem.company_extra_salary || {},
            employee_welfare_fund:
              this.editedItem.employee_welfare_fund != null
                ? this.editedItem.employee_welfare_fund
                : 0,
            bonus:
              this.editedItem.bonus != null ? this.editedItem.bonus : 0,
            employee_voluntary_pension: !!this.editedItem.employee_voluntary_pension,
            employee_voluntary_pension_rate:
              this.editedItem.employee_voluntary_pension_rate || 0,
            insurance_bracket_max:
              this.editedItem.insurance_bracket_max ?? null,
            dependent_insured_count:
              Number(this.editedItem.dependent_insured_count) || 0,
            extra_insurance: this.editedItem.extra_insurance || null,
            contact_person: this.editedItem.contact_person || "",
            contact_phone: this.editedItem.contact_phone || "",
            contact_relation: this.editedItem.contact_relation || "",
            blood_type: this.editedItem.blood_type || "",
            native_place: this.editedItem.native_place || "",
            gender: this.editedItem.gender || "",
            birthday: this.editedItem.birthday || null,
            marital_status: this.editedItem.marital_status || "未婚",
            military_status: this.editedItem.military_status || "免役",
            nationality: this.editedItem.nationality || "",
            highest_education: this.editedItem.highest_education || "",
            passport_no: this.editedItem.passport_no || "",
            home_phone: this.editedItem.home_phone || "",
            registered_city: this.editedItem.registered_city || "",
            registered_region: this.editedItem.registered_region || "",
            registered_address: this.editedItem.registered_address || "",
            mailing_city: this.editedItem.mailing_city || "",
            mailing_region: this.editedItem.mailing_region || "",
            mailing_address: this.editedItem.mailing_address || "",
            english_name: this.editedItem.english_name || "",
            insured_unit: this.editedItem.insured_unit || "",
            note: this.editedItem.note || "",
          },
        };

        console.log("API 請求資料:", userData);

        // Create new user
        const response = await this.$axios.post("/api/users", userData);

        console.log("API 回應:", response.data);

        // Close the create dialog first
        this.close();

        // Show success dialog
        this.infoDialog.title = "操作成功";
        this.infoDialog.message = "員工新增成功！";
        this.infoDialog.yesCallback = async () => {
          // Refresh user list after user clicks OK
          await this.fetchUsers();
          // Clear callback
          this.infoDialog.yesCallback = null;
        };
        this.infoDialog.visible = true;
      } catch (error) {
        console.error("Error saving user:", error);
        console.log("error.response", error.response);
        const errorMsg =
          error.response?.data?.detail ||
          error.response?.data?.message ||
          "新增員工失敗";
        console.log(errorMsg);
        alert(errorMsg);
      } finally {
        this.saving = false;
      }
    },
    //
    async sendMessageToUser() {
      if (!this.editedItem || !this.editedItem.id) return;
      try {
        const user_id = this.editedItem.id;
        const message = this.editedItem.message;
        await this.$axios.post(
          `/api/users/${user_id}/message`,
          { data: message },
          {
            headers: { Authorization: `Bearer ${this.userToken}` },
          }
        );

        this.infoDialog.title = "操作成功";
        this.infoDialog.message = "訊息發送成功";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
        this.dialogSendMessage = false;
      } catch (error) {
        console.error("send message error", error);
        const errorMsg =
          error.response?.data?.message || error.message || "訊息發送失敗";
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = errorMsg;
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      }
    },

    triggerBulkFileSelect() {
      if (this.$refs.bulkFileInput) {
        this.$refs.bulkFileInput.click();
      }
    },
    async onBulkFileChange(event) {
      const file =
        event && event.target && event.target.files
          ? event.target.files[0]
          : null;
      if (!file) return;

      this.bulkUploadFile = file;
      this.confirmDialog.title = "確認上傳";
      this.confirmDialog.message = `即將上傳檔案：${file.name}`;
      this.confirmDialog.yesButtonText = "開始上傳";
      this.confirmDialog.noButtonText = "取消";
      this.confirmDialog.yesCallback = async () => {
        this.showProgressDialog = true;
        this.progressMessage = "正在上傳檔案...";
        try {
          await this.performBulkUpload();
          // Ensure progress dialog shows for at least 500ms
          await new Promise((resolve) => setTimeout(resolve, 500));
        } finally {
          this.showProgressDialog = false;
        }
        this.confirmDialog.yesCallback = null;
      };
      this.confirmDialog.visible = true;
      if (this.$refs.bulkFileInput) this.$refs.bulkFileInput.value = "";
    },

    async performBulkUpload() {
      if (!this.bulkUploadFile) return;
      try {
        const formData = new FormData();
        formData.append("file", this.bulkUploadFile);
        formData.append("company_id", this.company_id);

        const res = await this.$axios.post("/api/users/bulk-upload", formData, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
            "Content-Type": "multipart/form-data",
          },
          transformRequest: [(data) => data],
        });

        const resp = res && res.data ? res.data : {};
        const errs = Array.isArray(resp.errors) ? resp.errors : [];
        this.infoDialog.title = errs.length > 0 ? "部分失敗" : "操作成功";
        this.infoDialog.message = resp.message || "上傳成功";
        if (errs.length > 0) {
          const details = errs
            .map(
              (e) =>
                `第${e.row}列 工號:${e.member_id} 手機:${e.mobile_phone} - ${e.error}`
            )
            .join("\n");
          this.infoDialog.message = `${this.infoDialog.message}\n${details}`;
        }
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = async () => {
          await this.fetchUsers();
          this.infoDialog.yesCallback = null;
        };
        this.infoDialog.visible = true;
      } catch (error) {
        console.error("Bulk upload error:", error);
        const errorMsg =
          error.response?.data?.message || error.message || "上傳失敗";
        this.infoDialog.title = "操作失敗";
        this.infoDialog.message = `上傳檔案失敗：${errorMsg}`;
        this.infoDialog.yesButtonText = "確定";
        this.infoDialog.yesCallback = null;
        this.infoDialog.visible = true;
      } finally {
        this.bulkUploadFile = null;
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    // watch company_id changes
    company_id() {
      this.fetchUsers();
    },
  },
};
</script>

<style scoped>
/* Grid View Styles */
.grid-view-container {
  padding: 1rem;
}

.user-card {
  transition: all 0.3s ease;
  height: 100%;
}

.user-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.text-sm {
  font-size: 0.875rem;
}

.h-100 {
  height: 100%;
}

/* Data Table Styles */
.table >>> thead th {
  white-space: nowrap;
  font-size: 1rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.025rem;
  color: #8392ab;
  opacity: 0.7;
  padding: 0.75rem 1.5rem;
  border-bottom: 0.0625rem solid #e9ecef;
}

.table >>> tbody tr:last-child td {
  border-bottom: 0;
}

.table >>> tbody td {
  padding: 0.75rem 1.5rem;
  border-bottom: 0.0625rem solid #e9ecef;
}

.table >>> tbody tr:hover {
  background: #f8f9fa;
}
</style>
